import { render, staticRenderFns } from "./ed-modal-agreement.component.vue?vue&type=template&id=af56071a&scoped=true&"
import script from "./ed-modal-agreement.component.ts?vue&type=script&lang=ts&"
export * from "./ed-modal-agreement.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-modal-agreement.component.scss?vue&type=style&index=0&id=af56071a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af56071a",
  null
  
)

export default component.exports